export const getImageShimmerStyles = () => ({
  '@global': {
    '@keyframes image_shimmer': {
      '0%': { backgroundPosition: '0%' },
      '100%': { backgroundPosition: '100%' },
    },
  },
  imageShimmerRoot: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    overflow: 'hidden',
    backgroundSize: '400% 100%',

    animationName: 'image_shimmer',
    animationDuration: '1.5s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate',
    animationIterationCount: 'infinite',
  },
});
